import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlertsStore } from '../state/AlertsContainer';
import { useCurrentUserStore } from '../state/CurrentUserContainer';

export const usePasswordManager = () => {
    const { t } = useTranslation();

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');

    const handleSavePassword = async () => {
        try {
            if (!validatePasswordInputs()) return;

            const result = await useCurrentUserStore
                .getState()
                .updatePassword(oldPassword, newPassword, confirmNewPassword);
            handlePasswordSaveResult(result);
        } catch (error) {
            console.error('Failed to update password:', error);
            useAlertsStore.getState().showError(t('common:account.error.generic'));
        }
    };

    const validatePasswordInputs = () => {
        if (!oldPassword) {
            useAlertsStore.getState().showError(t('common:account.error.old'));
            return false;
        }
        if (!newPassword) {
            useAlertsStore.getState().showError(t('common:account.error.new'));
            return false;
        }
        if (newPassword !== confirmNewPassword) {
            useAlertsStore.getState().showError(t('common:account.error.match'));
            return false;
        }
        return true;
    };

    const handlePasswordSaveResult = (result: any) => {
        if (result?.resultType === 'Ok') {
            useAlertsStore.getState().showSuccess(t('common:account.success.password'));
            resetPasswordFields();
        } else {
            useAlertsStore.getState().showError(result?.errors?.join(', ') ?? t('common:account.error.password'));
        }
    };

    const resetPasswordFields = () => {
        setOldPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
    };

    return {
        oldPassword,
        newPassword,
        confirmNewPassword,
        setOldPassword,
        setNewPassword,
        setConfirmNewPassword,
        handleSavePassword,
    };
};
